<template>
	<div v-if="obj.length == 0">
		<Loding></Loding>
	</div>
	<div class="chain" v-else>
		<!-- 从参数开始显示隐藏导航栏 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>店铺详情</span>
			<span></span>
		</div>
		<!-- 店铺信息 -->
		<div class="list">
			<van-card>
				<div slot="title" class="list_title">
					<div>{{obj.title}}</div>
				</div>
				<div slot="desc" class="list_desc">
					<div>{{obj.business}}</div>
					<!-- 店铺图片信息 -->
					<div class="swiper_img">
						<ul>
							<li v-for="(item, index) in obj.slider_image">
								<img :src="item | handleUrl" @click="getImg(obj.slider_image, index)"></img>
							</li>
						</ul>
					</div>
				</div>
				<div slot="tags" class="list_tags">
					<div>
						<van-tag color="#F1452F" round v-if="obj.category === 1">个体</van-tag>
						<van-tag color="#F1452F" round v-else>公司</van-tag>
						<van-tag color="#F1452F" round>已认证</van-tag>
					</div>
					<div class="browse">
						此商户已被浏览{{obj.browse}}次
					</div>
				</div>
				<div slot="price-top" class="list_priceTop">
					<div class="list_priceTop_left">
						<div>总评分</div>
						<div class="star">{{obj.fraction}}</div>
						<van-rate v-model="obj.fraction/2" :allow-half="true" color="#F1452F" size="0.8rem" readonly />
					</div>
					<div class="list_priceTop_right" @click="callPhone(obj.tel)">
						<van-icon name="phone" size="1.5rem" />
						<div>
							<span>
								{{obj.tel | phoneNumFilter}}
							</span>
							<span>免费咨询</span>
						</div>
					</div>
				</div>
				<div slot="bottom" class="list_bottom">
					<div>
						<img src="../../assets/address.png" style="width:0.8rem;height:0.8rem" alt="">
						<div>&nbsp;{{obj.province}}{{obj.city}}{{obj.area}}{{obj.address}}</div>
					</div>
					<div>
						<div>距您当前位置{{obj.km}}km</div>
					</div>
				</div>
			</van-card>
		</div>
		<!-- 评价 -->
		<div class="discuss">
			<div class="title" @click="toComment">
				<div>
					<span class="special-span">评价</span>
					<span class="special-num" v-if="obj.thirdparty_comment.length === 0">共0条评论</span>
					<span class="special-num" v-else>共{{obj.count}}+条评论</span>
				</div>
				<div>
					<span>好评度98%</span>
					<van-icon name="arrow" color="#F1452F" />
				</div>
			</div>
			<div class="main_null" v-if="obj.thirdparty_comment.length === 0">
				暂无评价
			</div>
			<div class="main" v-else>
				<div class="list" v-for="item in obj.thirdparty_comment">
					<div class="user" v-if="item.user >0 ">
						<img src="../../assets/touxiang.png" alt="" v-if="item.anonymous == 2">
						<img src="../../assets/user.png" alt="" v-else-if="item.user.image == null">
						<img :src="item.user.image " alt="" v-else>
						<div class="user_name">
							<span class="user-span" v-if="item.anonymous == 2">匿名</span>
							<span class="user-span" v-else>{{item.user.username}}</span>
						</div>
						<div class="time">{{item.create_time}}</div>
					</div>
					<div class="user-msg">{{item.content}}</div>
					<div class="user_img" v-if="item.image >0 ">
						<img :src="items" alt="" v-for="items in item.image">
					</div>
				</div>
			</div>
			<div class="see">
				<van-button round size="mini" style="padding:0 1rem" type="default" @click="goScore">我要评论</van-button>
				<van-button round size="mini" style="padding:0 0.5rem" plain color="#F1452F" @click="toComment">查看全部评价
				</van-button>
			</div>
		</div>
		<!-- 业务详情 -->
		<van-panel title="业务简介">
			<div>
				<div>{{obj.content}}</div>
			</div>
		</van-panel>
		<!-- 业务图片 -->
		<van-panel title="业务图片">
			<img :src="item | handleUrl" alt="" v-for="item in obj.image">
		</van-panel>
		<!-- 精品推荐 -->
		<van-divider :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">精品推荐</van-divider>
		<div class="lateral-sliding">
			<div class="lateral-sliding-item" v-for="item in obj.thirdparty_list" v-if="item.id != $route.query.id" @click="goDetail(item.id)">
				<div>
					<img :src="item.slider_image[0] | handleUrl" alt="">
					<div class="lateral-title">{{item.title}}</div>
					<div class="lateral-business">{{item.business}}</div>
					<div class="lateral-address">{{item.city}}{{item.area}}</div>
				</div>
			</div>
		</div>
		<!-- 俱百家提醒您 -->
		<div class="serve">
			<div>俱百家提醒您</div>
			<p>
				办理业务前请勿提前支付款项，付款请认真审核商家资质，
				显示已认证的商户为俱百家平台审核过的商户，显示官方推荐的商户为平台有押金的商户请放心使用，
				为了保证您的合法权益三次差评的商户我们立即做下架处理。您的每一次认真的评价就是对我们商户成长的一次历练谢谢您的理解与支持！400-8722-000
			</p>
		</div>
		<!-- <div class='tip'>
      如遇虚假、诈骗信息或服务纠纷，请立即举报服务过程请注意保存证据，谨防诈骗.<span @click="callPhone('400-8722-000')">立即投诉</span>
    </div> -->
		<!-- <van-goods-action>
      <van-goods-action-icon icon="wap-home-o" text="首页" to="/Home" />
      <van-goods-action-icon icon="like-o" text="收藏" @click="onClickIcon"/>
      <van-goods-action-button type="warning" text="我要评论" @click="goScore" />
      <van-goods-action-button type="danger" text="拨打电话" @click="callPhone(obj.tel)" />
    </van-goods-action> -->
		<!-- 预览图 -->
		<van-image-preview v-model="show" :startPosition="startPosition" :images="image"></van-image-preview>
		<!--登录 -->
		<van-popup v-model="loginPopupShow" position="bottom" :style="{ height: '100%' }">
			<div class="close-icon" @click="loginPopupShow=false">关闭</div>
			<Login></Login>
		</van-popup>
	</div>
</template>

<script>
	import Login from '@/components/login/login'
	import Loding from '@/components/loding'
	import Customerservice from '@/components/customerservice'

	export default {
		data() {
			return {
				active: 0,
				current: 0, //轮播图指示器
				obj: '',
				show: false,
				image: [],
				startPosition: '',
				loginPopupShow: false,
				route: ''
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Category/thirdpartyInfo', {
				id: this.$route.query.id,
				lng: this.$store.state.location[0],
				lat: this.$store.state.location[1]
			}).then((res) => {
				if (res.data.code === 2) {
					this.obj = res.data.data;
				}
			}).catch((err) => {})
		},
		methods: {
			//全部评论
			toComment() {
				this.$router.push({
					path: '/tpcomment',
					query: {
						id: this.$route.query.id
					}
				})
			},
			// 调用拨号功能
			callPhone(phoneNumber) {
				window.location.href = 'tel://' + phoneNumber
			},
			//推荐详情
			goDetail(id) {
				this.$router.push({
					path: '/chain',
					query: {
						id: id
					}
				})
			},
			//预览图
			getImg(img, index) {
				this.startPosition = index;
				this.image = [];
				this.show = true;
				for (var item in img) {
					if (item != 'undefined') {

						this.image.push(baseUrl + '/uploads/' + img[item]);
					}
				}
			},
			goScore() {
				this.whatLogin((bool) => {
					if (bool) {
						this.$axios.post(baseUrl + '/mobile/user/whatUserTime', {
							token: localStorage.getItem('Authorization')
						}).then((res) => {
							if (res.data.code === 1011) {
								this.$axios.post(baseUrl + '/mobile/Category/thirdpartyWhatComment', {
									id: this.$route.query.id,
									token: localStorage.getItem('Authorization')
								}).then((res) => {
									if (res.data.code === 21) {
										this.$router.push({
											path: '/score',
											query: {
												id: this.$route.query.id
											}
										})
									} else {

										this.$toast(res.data.msg);
									}
								}).catch((err) => {})
							} else {
								this.$toast(res.data.msg);
							}
						}).catch((err) => {})
					} else {
						this.loginPopupShow = true;
					}
				})
			}
		},
		//收藏信息
		onClickIcon() {
			this.whatLogin((bool) => {
				if (bool) {
					this.$axios.post(baseUrl + '/mobile/Base/goodsCollection', {
						id: this.$route.query.id,
						token: localStorage.getItem('Authorization')
					}).then((res) => {
						if (res.data.code == 15) {
							this.$toast(res.data.msg);
							this.collection = !this.collection;

						} else if (res.data.code == 17) {
							this.$toast(res.data.msg);
							this.collection = !this.collection;
						}
						this.shokaiww = false
					}).catch((err) => {
						console.log(err);
					})
				} else {
					this.isLogin = true;
				}
			})
		},

		watch: {
			//监听路由变化
			'$route'(to, from) {
				this.$router.go(0);
			}
		},
		components: {
			Login,
			Loding,
			Customerservice,
		}
	}
</script>

<style scoped>
	@import 'chain.css';

	.chain .browse {
		color: #b1b1b1;
	}
</style>



// WEBPACK FOOTER //
// src/components/class/chain.vue